/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
export * from './entry.defs.js';
export { main as default } from './entry.defs.js';
//# sourceMappingURL=entry.js.map